import React from 'react';
import {useFormState} from 'react-final-form';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {IAuthLoginFormError} from './IAuthLoginFormError';

import styles from './AuthLoginFormError.module.scss';

const AuthLoginFormError = ({classNames}: IAuthLoginFormError) => {
	const formState = useFormState();
	const intl = useIntl();

	if (!formState.submitError) {
		return null;
	}

	return (
		<div role="alert" className={cn(styles['auth__login-form__error'], classNames)}>
			{intl.formatMessage(formState.submitError.message)}
		</div>
	);
};

export default AuthLoginFormError;
